/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum BusinessUnit {
    Cybersecurity = 'CYBERSECURITY',
    FinanceControl = 'FINANCE & CONTROL',
    GroupControl = 'GROUP CONTROL',
    WrtsilIndia = 'WÄRTSILÄ INDIA',
    GasSolutions = 'GAS SOLUTIONS',
    Ma = 'M&A',
    KasSupport = 'KAS SUPPORT',
    AmericanHydro = 'AMERICAN HYDRO',
    SpecialProducts = 'SPECIAL PRODUCTS',
    BusinessDevelopmentFinanceControl = 'BUSINESS DEVELOPMENT, FINANCE & CONTROL',
    Sales = 'SALES',
    VsQhse = 'VS QHSE',
    LegalAffairsHq = 'LEGAL AFFAIRS - HQ',
    Americas = 'AMERICAS',
    MarineLegalAffairs = 'MARINE LEGAL AFFAIRS',
    BusinessDevelopment = 'BUSINESS DEVELOPMENT',
    MarineBusinessAreaEuropeAfrica = 'MARINE BUSINESS AREA EUROPE & AFRICA',
    WrtsilChina = 'WÄRTSILÄ CHINA',
    IntellectualAssetManagement = 'INTELLECTUAL ASSET MANAGEMENT',
    StrategicDevelopment = 'STRATEGIC DEVELOPMENT',
    Sustainability = 'SUSTAINABILITY',
    EnergyServices = 'ENERGY SERVICES',
    EntertainmentSystem = 'ENTERTAINMENT SYSTEM',
    Transas = 'TRANSAS',
    InvestorRelations = 'INVESTOR RELATIONS',
    Treasury = 'TREASURY',
    CoeTalentLeadership = 'COE, TALENT & LEADERSHIP',
    BrandManagement = 'BRAND MANAGEMENT',
    Propulsion = 'PROPULSION',
    VoyageSolutionsServices = 'VOYAGE SOLUTIONS SERVICES',
    HumanResources = 'HUMAN RESOURCES',
    WrtsilFinland = 'WÄRTSILÄ FINLAND',
    Marketing = 'MARKETING',
    PartsServices = 'PARTS SERVICES',
    InformationManagement = 'INFORMATION MANAGEMENT',
    GroupControlStrategy = 'GROUP CONTROL & STRATEGY',
    EnergyStorageOptimisation = 'ENERGY STORAGE & OPTIMISATION',
    Purchasing = 'PURCHASING',
    HrLocalOperations = 'HR LOCAL OPERATIONS',
    SamElectronicsGmbh = 'SAM ELECTRONICS GMBH',
    AfricaEurope = 'AFRICA & EUROPE',
    SuzhouFactory = 'SUZHOU FACTORY',
    HrInternalCommunications = 'HR & INTERNAL COMMUNICATIONS',
    WaterAndWaste = 'WATER AND WASTE',
    ProjectManagement = 'PROJECT MANAGEMENT',
    AgileBusinessDevelopment = 'AGILE BUSINESS DEVELOPMENT',
    FieldServicesWorkshops = 'FIELD SERVICES & WORKSHOPS',
    GlobalSupportFunctions = 'GLOBAL SUPPORT FUNCTIONS',
    Strategy = 'STRATEGY',
    PowerSupply = 'POWER SUPPLY',
    PeopleServicesCommunity = 'PEOPLE SERVICES COMMUNITY',
    MarineBusinessAreaAmericas = 'MARINE BUSINESS AREA AMERICAS',
    ShaftLineSolutions = 'SHAFT LINE SOLUTIONS',
    ProjectServices = 'PROJECT SERVICES',
    MarineElectricalSystems = 'MARINE ELECTRICAL SYSTEMS',
    AutomationDynamicPositioning = 'AUTOMATION & DYNAMIC POSITIONING',
    FutureTechnologies = 'FUTURE TECHNOLOGIES',
    InternalAudit = 'INTERNAL AUDIT',
    WrtsilFrance = 'WÄRTSILÄ FRANCE',
    DigitalCommunicationsNetwork = 'DIGITAL & COMMUNICATIONS NETWORK',
    MiddleEastAsia = 'MIDDLE EAST & ASIA',
    OpenInnovation = 'OPEN INNOVATION',
    CommunicationOperationsDevelopment = 'COMMUNICATION OPERATIONS & DEVELOPMENT',
    SingaporeEcosystem = 'SINGAPORE ECOSYSTEM',
    FinanceBusinessControl = 'FINANCE & BUSINESS CONTROL',
    ExhaustTreatment = 'EXHAUST TREATMENT',
    TankControlSystems = 'TANK CONTROL SYSTEMS',
    NavcomSmartSensors = 'NAVCOM & SMART SENSORS',
    PerformanceServices = 'PERFORMANCE SERVICES',
    LegalAffairsEnergyBusiness = 'LEGAL AFFAIRS - ENERGY BUSINESS',
    TechnologyProductManagement = 'TECHNOLOGY & PRODUCT MANAGEMENT',
    CoeStrategyInsights = 'COE STRATEGY INSIGHTS',
    CoePerformanceRewarding = 'COE PERFORMANCE REWARDING',
    StrategyAndBusinessDevelopment = 'STRATEGY AND BUSINESS DEVELOPMENT',
    GroupSharedServiceCentre = 'GROUP SHARED SERVICE CENTRE',
    CorporateRelationsLegalAffairsAdmin = 'CORPORATE RELATIONS & LEGAL AFFAIRS-ADMIN',
    DigitalFinancePerformanceManagement = 'DIGITAL FINANCE PERFORMANCE MANAGEMENT',
    TechnologyOffice = 'TECHNOLOGY OFFICE',
    MarketingCommunications = 'MARKETING COMMUNICATIONS',
    TransformationProgramsStrategy = 'TRANSFORMATION PROGRAMS STRATEGY',
    FinanceLegal = 'FINANCE LEGAL',
    ProductGroupNacosCore = 'PRODUCT GROUP NACOS CORE',
    CustomerSuccess = 'CUSTOMER SUCCESS',
    Compliance = 'COMPLIANCE',
    HrGlobalFunctions = 'HR GLOBAL FUNCTIONS',
    IndirectPurchasing = 'INDIRECT PURCHASING',
    EnginePowerPlants = 'ENGINE POWER PLANTS',
    Voyage = 'VOYAGE',
    Security = 'SECURITY',
    CorporateCommunications = 'CORPORATE COMMUNICATIONS',
    PartsAndFieldService = 'PARTS AND FIELD SERVICE',
    Unknown = 'Unknown'
}

export function BusinessUnitFromJSON(json: any): BusinessUnit {
    return BusinessUnitFromJSONTyped(json, false);
}

export function BusinessUnitFromJSONTyped(json: any, _: boolean): BusinessUnit {
    return json as BusinessUnit;
}

export function BusinessUnitToJSON(value?: BusinessUnit | null): any {
    return value as any;
}
